import { Link } from "react-router-dom";
import { news } from "@/mocks/news";
import SectionHeading from "@/components/base/SectionHeading";
import type { NewsItem } from "@/types";

const list = news as NewsItem[];
const head = list[0];
const rest = list.slice(1, 5);

export default function NewsList() {
  return (
    <div className="min-w-0">
      <SectionHeading
        title="最新影视资讯"
        subtitle="行业动态、剧集新闻与演员快讯"
        moreLink="/news"
        moreText="全部资讯"
      />

      <Link
        to={`/news/${head.id}`}
        className="group block bg-background-50 rounded-lg border border-background-200 overflow-hidden hover:border-primary-300 transition-colors cursor-pointer mb-4"
      >
        <div className="flex flex-col sm:flex-row">
          <div className="w-full sm:w-64 h-44 sm:h-auto shrink-0 overflow-hidden bg-background-200">
            <img
              src={head.cover}
              alt={head.title}
              title={`${head.title} - 漂亮的保姆`}
              className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
          </div>
          <div className="p-4 md:p-5 min-w-0">
            <div className="flex items-center gap-2 mb-2">
              <span className="px-2 py-0.5 rounded-md bg-accent-100 text-accent-700 text-xs font-medium">
                {head.category}
              </span>
              <span className="text-xs text-foreground-400">{head.date}</span>
            </div>
            <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-2">
              {head.title}
            </h3>
            <p className="mt-2 text-sm text-foreground-500 line-clamp-2">
              {head.summary}
            </p>
          </div>
        </div>
      </Link>

      <ul className="bg-background-50 rounded-lg border border-background-200 divide-y divide-background-200">
        {rest.map((n) => (
          <li key={n.id}>
            <Link
              to={`/news/${n.id}`}
              className="group flex items-start gap-4 p-4 hover:bg-background-100 transition-colors cursor-pointer"
            >
              <span className="text-primary-500 text-lg mt-0.5 shrink-0">
                <i className="ri-newspaper-line" />
              </span>
              <div className="min-w-0 flex-1">
                <h4 className="text-sm md:text-base font-medium text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                  {n.title}
                </h4>
                <p className="mt-1 text-xs md:text-sm text-foreground-500 line-clamp-1">
                  {n.summary}
                </p>
              </div>
              <span className="text-xs text-foreground-400 shrink-0 mt-0.5">
                {n.date}
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}